import { Element } from 'slate'
import { isValidSlateElement } from '@tunasong/models'

/** Required for some legacy elements that do not have children set */
export const normalizeElement = <T extends Element = Element>(node: T) =>
  isValidSlateElement(node) ? node : { ...node, text: undefined, children: [{ text: '' }] }
// isValidSlateElement(node) ? node : { ...node, children: [{ type: 'line', children: [{ text: '' }] }] }
